<template>
  <div >
    <router-view></router-view>
    <index-card :loading="loading">
      <template slot="header">
        <div class="d-flex align-center">
          <v-btn text icon large to="/" exact><v-icon class="white--text">mdi-arrow-left</v-icon></v-btn>
          <v-btn color="white" class="ml-1 blue-grey--text elavation-0 font-weight-bold" @click="$router.push('/economic_groups/create')"
              center>
              <v-icon small left>mdi-plus</v-icon>Novo Grupo
          </v-btn>
        </div>
        <div class="d-flex align-center">
          <span class="headline white--text">
            Grupos Econômicos
          </span>
          <v-btn text icon @click="getData()" exact><v-icon class="white--text">mdi-refresh</v-icon></v-btn>
        </div>
      </template>
      <template slot="subheader">
        <div class="economic-groups-filters">
          <filter-data
            :with_client="false"
            :with_date_start="false"
            :with_date_end="false"
            with_text_search
            text_search_label="Buscar"
            :loading_block="loading"
            @doneFilter="handleDoneFilter"
          />
        </div>
      </template>
      <template slot="data_table">
        <v-data-table :headers="headers" :items="economic_groups"
          class="elevation-4" :search="search" v-if="!loading" mobile-breakpoint="1">
          <template v-slot:item.actions="{item}">
            <div class="d-flex justify-center align-center">
              <v-btn @click="showEconomicGroup(item)" small icon class="primary">
                <v-icon class="white--text" small>mdi-pencil</v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </template>
    </index-card>
    
  </div>
</template>

<script>
import Api from '@/api/index';

export default {
  name: 'EconomicGroups',
  components:{
    IndexCard: () => import("@/_backoffice/_registrations/components/shared/index/IndexCard.vue"),
    FilterData: () => import('@/components/shared/FilterData.vue'),
  },
  data() {
    return {
      loading: false,
      search: '',
      economic_groups: [],
      headers: [
        { text: 'Nome', value: 'attributes.name', align: 'center' },
        { text: 'Qtd. Clientes', value: 'attributes.clients_count', align: 'center' },
        { text: 'Ações', value: 'actions', align: 'center' },
      ],
    }
  },
  methods: {
    getData(){
      this.getEconomicGroups()
    },
    handleDoneFilter(filter = {}) {
      this.search = filter.query ? String(filter.query) : ''
    },
    getEconomicGroups(){
      this.loading = true
      Api.EconomicGroup.index().then((res)=>{
        this.economic_groups  = [...res.data.data]
      }).finally(()=>{
        this.loading = false
      })
    },
    showEconomicGroup(economic_group){
      this.$router.push({name: "ShowEconomicGroup", params:{ id: economic_group.id }})
    },
  },
  mounted() {
    this.getData()
  },
}
</script>

<style scoped>
.economic-groups-filters {
  width: 100%;
  flex: 1 1 100%;
  min-width: 0;
}
.economic-groups-filters >>> .filter-data-card {
  width: 100%;
}
</style>

